import { FC, useMemo } from 'react';
import { Skeleton } from 'antd';
import type { TAvatarTextProps } from './';
import * as Styled from './styles';

export const AvatarTextSkeleton: FC<TAvatarTextProps> = ({
  className,
  size = 'medium',
  shape = 'round',
  secondaryText,
  showAvatar = true
}) => {
  const isOneLine = useMemo(
    () => size === 'small' || !secondaryText,
    [size, secondaryText]
  );

  return (
    <Styled.AvatarTextWrapper
      className={className}
      $size={size}
      $shape={shape}
      $oneLine={isOneLine}
      $clickable={false}
    >
      {showAvatar && (
        <Styled.AvatarFallback>
          <Skeleton.Avatar shape="circle" active />
        </Styled.AvatarFallback>
      )}
      <Styled.PrimaryText>
        <Skeleton.Button
          block
          active
          style={{
            height: '16px',
            width: '80%',
            margin: '2 0'
          }}
        />
      </Styled.PrimaryText>
      {!isOneLine && (
        <Styled.SecondaryText>
          <Skeleton.Button
            block
            active
            style={{
              height: '16px',
              width: '60%',
              margin: '2 0'
            }}
          />
        </Styled.SecondaryText>
      )}
    </Styled.AvatarTextWrapper>
  );
};
